import React, {Component} from 'react';
import {Link} from "react-router-dom";
import InfiniteScroll from 'react-infinite-scroller';
import CategoryComponent from './CategoryComponent';
import {ApiBaseUrl} from '../../../constants';
import { trackPromise } from 'react-promise-tracker';
import {withSnackbar} from "react-simple-snackbar";

class CategoriesComponent extends Component{
    state = {
        hasMoreItems: true,
        page: 1,
        categories: [],
        similar_vendor_count: null
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(nextState.page !== this.state.page)
            return true;
        else
            return false;
    }

    loadItems(page) {
        let requestBody = '';
        if(this.props.category_id)
            requestBody = "cat_id=" + encodeURIComponent(this.props.category_id);
        page=this.state.page;
        var url = ApiBaseUrl+'/consumer/allday/cat_deals?page='+page;

        trackPromise(
        fetch(url,{
            method: 'POST',
            body: requestBody,
            headers:
                {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
        })
            .then(res => res.json())
            .then(
                (result) => {
                    result.data.categories.map(category => (
                        this.state.categories.push(category)
                    ));

                    if(result.data.categories.length > 0) {
                        document.getElementById('body').className = 'pagi-page'
                        this.setState({hasMoreItems: true, page: this.state.page+1, similar_vendor_count: result.data.similar_vendor_count})
                    }
                    else
                        this.setState({hasMoreItems: false})
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        hasMoreItems: false,
                    });
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    componentWillUnmount () {
        document.getElementById('body').className=''
    }

    render(){
        var cats = [];
        let msg = null;
        if(this.state.categories.length===0) {
            msg = (<div className="col-12 text-center text-white">
                No per person deals available.
            </div>)
        }
        else {
            this.state.categories.forEach((category, index) => {
                //this.state.categories.map( (category, index) => {
                if (index === 1 && this.state.similar_vendor_count > 1)
                    cats.push(
                        <div className="center_heading mb-4" key="similar_deals">
                            <p>Similar Deals from other vendors</p>
                            <span>
                            <img src={`${process.env.PUBLIC_URL}/image/similar_deals_icon.png`} alt=""/>
                        </span>
                        </div>
                    );
                cats.push(
                    <CategoryComponent index={index} key={category._id} category={category}
                                       similar_vendor_count={this.state.similar_vendor_count}/>
                );
                if (index + 1 === this.state.similar_vendor_count)
                    cats.push(
                        <div className="center_heading mb-4" key="change_vendor">
                            <Link to={`${process.env.PUBLIC_URL}`}><span> Change Vendor</span> <img
                                src={`${process.env.PUBLIC_URL}/image/change-icon-1.png`} alt=""/></Link>
                        </div>
                    )
            })
        }
        return (
            <React.Fragment>
                {msg}
                <InfiniteScroll
                    pageStart={1}
                    loadMore={this.loadItems.bind(this)}
                    hasMore={this.state.hasMoreItems}>
                    {cats}
                </InfiniteScroll>
            </React.Fragment>
        );
    }
}

export default withSnackbar(CategoriesComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});